// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { GraphQLAuthMode } from '@aws-amplify/core/dist/esm/libraryUtils';

export const environment: any = {
  version: require('../../package.json').version,
  production: true,
  name: 'PROD',
  prefixVersion: '',
  locale: 'en',
  homeRoot: '/dashboard',
  providers: {
    api: {
      url: 'https://api.demo.saesl.thelogchain.com/api',
      auth: {
        type: 'Bearer',
      },
    },
  },
  GRAFANA: {
    BASE_URL: 'https://demo.saesl.mobile.thelogchain.com/grafana',
    DASHBOARD_UID: 'adrqtt4',
    DASHBOARD_SLUG: 'logchain-pmo-operations-dashboard-saesl-demo',
  },
  AWS_CONFIG: {
    Auth: {
      Cognito: {
        userPoolId: 'ap-southeast-1_pzDntYaF3',
        userPoolClientId: '68l05vti2vud6gq7o2e14htfkh',
        identityPoolId: 'ap-southeast-1:9a849aef-a850-4047-afd5-8cc1321b67c9',
		loginWith: {
          oauth: {
            userPoolClientIdMS: '4rgotkgvtrh6g5ei4r73k8eqph',
            domain: 'logchain-microsoft.auth.ap-southeast-1.amazoncognito.com',
            scopes: ['openid', 'email', 'profile'],
            redirectSignIn: ['https://demo.saesl.thelogchain.com/'],
            redirectSignOut: ['https://demo.saesl.thelogchain.com/'],
            responseType: 'code' as const,
            msClientID: '718cf9a6-a569-413e-8bfe-2e9991db442b',
            msRedirectUrl:
              'https://demo.saesl.thelogchain.com/auth/microsoft-callback',
          },
        },
      },
    },
    Storage: {
      S3: {
        bucket: 'logchain-saesl-sg',
        region: 'ap-southeast-1',
      },
    },
    API: {
      GraphQL: {
        endpoint:
          'https://i5beb7i2qbf7xfwn5d4vrm6h6e.appsync-api.ap-southeast-1.amazonaws.com/graphql',
        region: 'ap-southeast-1',
        defaultAuthMode: 'userPool' as GraphQLAuthMode,
      },
    },
  },
  google_api_key: 'AIzaSyD1upPg36BJSXySxBF-0vOHjY0sUpS8t_E',
  host: 'https://api.demo.saesl.thelogchain.com',
  firebase: {
    apiKey: 'AIzaSyD_Sa3uVPi8tplwkY8KXfNrbdqdPYd-n6Q',
    authDomain: 'lc-dev-be9e8.firebaseapp.com',
    projectId: 'lc-dev-be9e8',
    databaseURL: 'https://lc-dev-be9e8.firebaseio.com',
    storageBucket: 'lc-dev-be9e8.appspot.com',
    messagingSenderId: '493108013284',
    appId: '1:493108013284:web:f6c05f1c0ac3d6fe0164f1',
    measurementId: 'G-LLZ37JMSHC',
  },
  LANGUAGE: {
    Default: 'en',
    Support: ['en', 'es', 'ja', 'zh'],
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

